import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '@max/shared/base-service/base-api.service';
import { AircraftBlueBookSearchCriteria } from '../models/aircraft-blue-book-search-criteria.model';
import { AircraftBlueBookImportModel } from '../models/aircraft-blue-book-import.model';
import { PaginatedResultModel } from '../../Foundation/models/paginated-result.model';
import { ValidatedResponse } from '../../shared/models/validated-response.model';
import { AircraftBlueBookImportEntryModel } from '../models/aircraft-blue-book-import-entry.model';

@Injectable()
export class AircraftBlueBookService extends BaseApiService {
    public getBlueBookEntry = (modelId: number, modelYear: number, aircraftValuationSourceTypeId: number): Observable<any> => this.get(`Aircraft/BlueBook/Model/${modelId}/Year/${modelYear}/Valuation/${aircraftValuationSourceTypeId}`);

    public searchBlueBook = (aircraftBlueBookSearchCriteria: AircraftBlueBookSearchCriteria): Observable<any> => this.post('Aircraft/BlueBook/Search', aircraftBlueBookSearchCriteria);

    public getBlueBookImports = (
        offset: number = 0, limit: number = 25, filter: string = null, sortBy: string = null, sortOrder: string = null
    ): Observable<PaginatedResultModel<AircraftBlueBookImportModel>> => {
        const params = { offset, limit, filter, sortBy, sortOrder };
        const query = Object.keys(params)
            .filter(k => params[k] !== null)
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
            .join('&');

        return this.get(`Aircraft/BlueBook/Imports${query ? '?' + query : query}`);
    };

    public createBlueBookImport = (model: AircraftBlueBookImportModel): Observable<ValidatedResponse<number>> => this.post('Aircraft/BlueBook/Imports', model);

    public getBlueBookImport = (aircraftBlueBookImportId: number): Observable<AircraftBlueBookImportModel> => this.get(`Aircraft/BlueBook/Imports/${aircraftBlueBookImportId}`);

    public commitBlueBookImport = (aircraftBlueBookImportId: number): Observable<any> => this.post(`Aircraft/BlueBook/Imports/${aircraftBlueBookImportId}/commit`, null);

    public getBlueBookImportEntries = (aircraftBlueBookImportId: number): Observable<ValidatedResponse<AircraftBlueBookImportEntryModel[]>> => this.get(`Aircraft/BlueBook/Imports/${aircraftBlueBookImportId}/Entries`);

    public saveBlueBookImportEntry = (model: AircraftBlueBookImportEntryModel): Observable<ValidatedResponse<number>> => this.post('Aircraft/BlueBook/Imports/Entries', model);
}
